import { render, staticRenderFns } from "./myFamilyList.vue?vue&type=template&id=0ac67992&scoped=true&"
import script from "./myFamilyList.vue?vue&type=script&lang=js&"
export * from "./myFamilyList.vue?vue&type=script&lang=js&"
import style0 from "./myFamilyList.vue?vue&type=style&index=0&id=0ac67992&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac67992",
  null
  
)

export default component.exports